import type { InvoiceReservationLookup } from '../../Service/reservationsLookupMapper';
import { termOf } from '../../utils/invoiceHelpers';
import type { ReservationOption } from './ReservationAutocomplete.types';

const sameText = (a?: string, b?: string): boolean =>
  !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();

// For organizations the backend sends the organization name as both first and last name.
export const buildApplicantName = (reservation: InvoiceReservationLookup): string => {
  const firstName = reservation.applicantFirstName ?? reservation.applicant?.firstName ?? '';
  const lastName = reservation.applicantLastName ?? reservation.applicant?.lastName ?? '';

  if (sameText(firstName, lastName)) {
    return firstName.trim();
  }

  return [firstName, lastName].filter(Boolean).join(' ');
};

export const buildReservationOption = (reservation: InvoiceReservationLookup): ReservationOption => {
  const applicant = buildApplicantName(reservation);
  const offerName = reservation.offerName ?? reservation.booking?.offerName;
  const label = [offerName || `Rezerwacja #${reservation.id}`, applicant]
    .filter(Boolean)
    .join(' • ');

  const term = termOf(
    reservation.dateFrom ?? reservation.booking?.bookingDateFrom,
    reservation.dateTo ?? reservation.booking?.bookingDateTo
  );
  const participantsCount =
    reservation.participantsCount ??
    reservation.numberOfParticipants ??
    (Array.isArray(reservation.participants) ? reservation.participants.length : undefined);
  const price = reservation.totalPrice ?? reservation.booking?.price;
  const buyer = sameText(reservation.invoiceBuyerName, applicant)
    ? undefined
    : reservation.invoiceBuyerName;

  const meta = [
    `#${reservation.id}`,
    term,
    buyer ? `nabywca: ${buyer}` : undefined,
    reservation.source,
    participantsCount ? `os.: ${participantsCount}` : undefined,
    price != null ? `suma: ${price}` : undefined,
  ]
    .filter(Boolean)
    .join(' • ');

  return { id: reservation.id, label, meta };
};
